import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { getMyAccountUrl, logout } from '@ten24/slatwall-storefront-react-private/global'
import { useState } from 'react'

const AccountBubble = ({ color = "", cssClass = "" }) => {
  const location = useLocation()
  const { t } = useTranslation()
  const user = useSelector(state => state.userReducer)
  const { accountID, firstName } = user

  // Changes - displays the Account icon, 
  // Alignment of the icon and text in a single row,
  // Text for logged out user just says "Sign In" instead of "hello, Sign in" 
  return (
    <Link to={getMyAccountUrl()} className={`p-2 link-button h-100 d-flex align-items-center align-self-lg-center user-account ${cssClass}`} style={{ color: color }}>
      <span className={`d-flex align-items-center text-center ${location?.pathname === '/my-account/overview' && `active`}`}>
        <i className="bi bi-person-circle account-bubble-icon me-2"></i>
        {/* <div className="fs-6 position-absolute top-1 start-100 translate-middle badge rounded-pill bg-primary">My account</div> */}
        <span className="d-block fw-bold">{accountID === '' ? ` ${t('frontend.account.sign_in')}` : ` ${t('frontend.core.hello')}, ${firstName}`}</span>
      </span>
    </Link>
  )
}

const RegisterSpecialMenu = ({ color = "", cssClass = "", linkLabel = "Register"}) => {
  const user = useSelector(state => state.userReducer)
  const { accountID } = user

  if(accountID === ''){
    return (
      <Link to={"/register"} className={`p-2 link-button h-100 d-flex align-items-center align-self-lg-center user-register ${cssClass}`} style={{ color: color }}>
        <span className={'d-flex align-items-center text-center'}>
          <i className="bi bi-person-plus-fill me-2"></i>
          <span className="d-block fw-bold">{linkLabel}</span>
        </span>
      </Link>
    )
  }
}

const LogoutSpecialMenu = ({ color = "", cssClass = "", linkLabel = "Logout"}) => {
  const user = useSelector(state => state.userReducer)
  const { accountID } = user
  const dispatch = useDispatch()
  const [disableButton, setdisableButton] = useState(false)
  const { t } = useTranslation()

  if(accountID){
    return (
      <Link to={"/"} className={`nav-item link-button h-100 d-flex align-items-center align-self-lg-center user-register ${cssClass}`} style={{ color: color }}>
        <Link
              disabled={disableButton}
              onClick={() => {
                setdisableButton(true)
                dispatch(logout(t('frontend.account.logout_success'), t('frontend.account.logout_failure')))
              }}
              classList="nav-link btn-link d-flex flex-row-reverse justify-content-end p-2 border-0 bg-transparent"
            >
          <span className="d-block fw-bold">{linkLabel}</span>
        </Link>
      </Link>
    )
  }
}


export { AccountBubble, RegisterSpecialMenu, LogoutSpecialMenu }
